import axios from "axios";

import "../../../setup/config/apiConfig";


export const GET_API_KEY_REQUEST = 'GET_API_KEY_REQUEST';
export const GET_API_KEY_RESPONSE = 'GET_API_KEY_RESPONSE';
export const GET_API_KEY_FAILURE = 'GET_API_KEY_FAILURE';

export const UPDATE_API_KEY_REQUEST = 'UPDATE_API_KEY_REQUEST';
export const UPDATE_API_KEY_RESPONSE = 'UPDATE_API_KEY_RESPONSE';
export const UPDATE_API_KEY_FAILURE = 'UPDATE_API_KEY_FAILURE';

export const CREATE_API_KEY_REQUEST = 'CREATE_API_KEY_REQUEST';
export const CREATE_API_KEY_RESPONSE = 'CREATE_API_KEY_RESPONSE';
export const CREATE_API_KEY_FAILURE = 'CREATE_API_KEY_FAILURE';

export const DELETE_API_KEY_REQUEST = 'DELETE_API_KEY_REQUEST';
export const DELETE_API_KEY_RESPONSE = 'DELETE_API_KEY_RESPONSE';
export const DELETE_API_KEY_FAILURE = 'DELETE_API_KEY_FAILURE';

export const CLEAR_API_KEY_STATE = 'CLEAR_API_KEY_STATE';

export function getApiKeys({page, rowsPerPage = 1000, search = '',resetCache=false}) {
  return async dispatch => {
    try {
      dispatch({
        type: GET_API_KEY_REQUEST,
        isLoading: true
      });
      const response = await axios.get(`api-keys?limit=${rowsPerPage}&page=${page}&search=${search}`);
      const {data, totalCount} = response.data;
      dispatch({
        type: GET_API_KEY_RESPONSE,
        data,
        totalCount,
        resetCache
      });
    } catch (error) {
      dispatch({
        type: GET_API_KEY_FAILURE,
        error: error?.message
      });
      throw error;
    }
  }
}

export function generatePMApiKeys(userId){
  return async dispatch => {
    try {
      dispatch({
        type: CREATE_API_KEY_REQUEST,
        isLoading: true
      });
      const response = await axios.post(`/register-api-key/${userId}`, { userId })
      dispatch({
        type: CREATE_API_KEY_RESPONSE,
        data: response.data,
        isLoading: false,
        error: null,
      });

    }catch (error) {
      dispatch({
        type: CREATE_API_KEY_FAILURE,
        error: error?.message
      });
      throw error;
    }
  }

}

export function clearApiKeyState(){
  return dispatch => dispatch({
    type: CLEAR_API_KEY_STATE,
  })
}

export function deleteApiKey(uuid){
  return async dispatch => {
    try{
      dispatch({
        type: DELETE_API_KEY_REQUEST,
        isLoading: true,
        error: null,
      })
      const response = await axios.delete(`/api-key/${uuid}`)
      console.log(response, 'response')
      dispatch({
        type: DELETE_API_KEY_RESPONSE,
        isLoading: false,
        error: null,
      })
    }catch (error) {
      dispatch({
        type: DELETE_API_KEY_FAILURE,
        isLoading: false,
        error: error?.message
      })
      console.log(error, "Error deleting api key");
    }
  }
}


export function updateApiKey({uuid, status, expirationDate, userId}){
  return async dispatch => {
    try{
      const params = {
        status,
        expirationDate
      }
      dispatch({
        type: UPDATE_API_KEY_REQUEST,
        isLoading: true,
        error: null,
      })
      await axios.put(`/api-key/${uuid}/${userId}`, params)
      dispatch({
        type: UPDATE_API_KEY_RESPONSE,
        isLoading: false,
        error: null,
      })
    }catch (error) {
      dispatch({
        type: UPDATE_API_KEY_FAILURE,
        isLoading: false,
        error: error?.message
      })
      throw error;
    }
  }
}

